export const ROLE_TYPES = {
  MD: { value: "2", code: "md", label: "MD/DO" },
  PHD: { value: "3", code: "phd", label: "PhD" },
  RN: { value: "4", code: "rn", label: "RN" },
  RCP: { value: "5", code: "rcp", label: "RCP" },
  STUDENT: { value: "6", code: "student", label: "Student" },
};

export const REG_TYPES = {
  IN_PERSON: { value: "2", code: "in_person", label: "In Person" },
  VIRTUAL: { value: "3", code: "virtual", label: "Virtual" },
};

export const AFFILIATION_TYPES = {
  PALICC: { value: 1, code: "palicc", label: "Affiliated with PALICC-2" },
  VENT_LIB: { value: 2, code: "vent_lib", label: "Affiliated with Vent Liberation" },
};

const optionCodeByValue = (options) => Object.values(options).reduce((codes, option) => {
  codes[String(option.value)] = option.code;
  return codes;
}, {});

const roleCodeByValue = optionCodeByValue(ROLE_TYPES);
const registrationCodeByValue = optionCodeByValue(REG_TYPES);
const affiliationCodeByValue = optionCodeByValue(AFFILIATION_TYPES);

export const mapRoleTypeToCode = (value) => roleCodeByValue[String(value)] || ROLE_TYPES.STUDENT.code;
export const mapRegTypeToCode = (value) => registrationCodeByValue[String(value)] || REG_TYPES.VIRTUAL.code;
export const mapAffiliationToCode = (values = []) => values.map((value) => affiliationCodeByValue[String(value)]).filter(Boolean);
